"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Events = exports.StandardEvents = void 0;
/** Name of the feature. */
exports.StandardEvents = 'standard:events';
/**
 * @deprecated Use {@link StandardEvents} instead.
 *
 * @group Deprecated
 */
exports.Events = exports.StandardEvents;
//# sourceMappingURL=events.js.map